import { TableHeader } from '@design/components/table';
import { flexRender, Header } from '@tanstack/react-table';
import { TooltipContainer } from '@terminal/components/tooltip-container/TooltipContainer';
import { Property } from 'csstype';

import styles from './CompaniesTableHeaderCell.module.scss';

const HEADER_CELL_HEIGHT = 41;

export const CompaniesTableHeaderCell = <T,>({
  header,
  headerGroupIdx,
  alignment,
  isHoverEnabled = true,
}: {
  header: Header<T, unknown>;
  headerGroupIdx: number;
  alignment: Property.TextAlign;
  isHoverEnabled?: boolean;
}) => {
  const isWithinParent = !!header.column.parent;
  const tooltip = header.column.columnDef.meta?.tooltip;
  const topPx = headerGroupIdx * (HEADER_CELL_HEIGHT - Number(isWithinParent));

  return (
    <TooltipContainer inPortal label={header.column.columnDef.meta?.tooltip}>
      <TableHeader
        colSpan={header.colSpan}
        alignment={alignment}
        isHoverEnabled={isHoverEnabled}
        className={styles.styledTableHeader}
        style={{ top: `${topPx}px` }}
        aria-haspopup={!!tooltip}
      >
        {flexRender(header.column.columnDef.header, header.getContext())}
      </TableHeader>
    </TooltipContainer>
  );
};
